﻿import nanoid from "./nanoid";

const itemMap: WeakMap<object, string> = new WeakMap<object, string>();

/**
 * Gets or generates a unique identifier for an object.
 * Uses a WeakMap to cache UIDs, ensuring the same UID is returned for the same object.
 * @param item The object to get a UID for.
 * @returns A unique string identifier for the object.
 */
export default function getObjectUID(item: object): string {
	if (itemMap.has(item)) {
		return itemMap.get(item)!;
	}

	const key = nanoid();
	itemMap.set(item, key);
	return key;
}
